import { AiMatchingRouteGate } from "../../../components/AiMatchingRouteGate";
import { DashboardPreview } from "../../DashBoard/DashboardPreview";
import { AdminDashboard } from "./AdminDashboard";

/** /admin/dashboard — legacy admin panel when flag off; Figma home when flag on. */
export const AdminDashboardRoute = () => (
  <AiMatchingRouteGate preview={<DashboardPreview />} legacy={<AdminDashboard />} />
);
